import { render } from "./chat_progress.vue?vue&type=template&id=2b133e52&scoped=true"
import script from "./chat_progress.vue?vue&type=script&lang=js"
export * from "./chat_progress.vue?vue&type=script&lang=js"

import "./chat_progress.vue?vue&type=style&index=0&id=2b133e52&scoped=true&lang=css"

import exportComponent from "/home/hkohashi/webinar-master-php83/frontend-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b133e52"]])

export default __exports__